export default __webpack_public_path__ + "react-assets/copy-icon.svg";